import { useLayoutEffect } from "react"
import { useLocation } from "react-router-dom"

export function usePageScrollReset(ref) {
    const { pathname } = useLocation()

    useLayoutEffect(resetScroll, [pathname, ref])

    function resetScroll() {
        const element = ref.current
        if (!element) return
        element.scrollTop = 0
        element.scrollLeft = 0
    }
}
